import { logError } from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';

import type { ContextLoginFormData } from '@web-platform/shared-universal-types/src/context';
import type { Nullable } from '@web-platform/shared-universal-types-utils/src/utils';

type LoginFormData = Nullable<ContextLoginFormData>;

let loginFormData: LoginFormData = null;

export const setLoginFormData = (newLoginFormData: LoginFormData) => {
  loginFormData = newLoginFormData;
};

export const getLoginFormData = () => {
  if (loginFormData === null) {
    const error = new Error('Login form data is not set.');
    logError({
      error,
      component: 'GlobalLoginForm',
      message: 'Error getting login form data',
    });
  }
  return loginFormData;
};
